{
  "holdingAreaListItem": {
    "imageAlt": "N/D",
    "tenantTypes": {
      "transient": "Tránsito",
      "base": "Base",
      "yellowCard": "Base + Tarjeta Amarilla"
    },
    "unknownModel": "Modelo desconocido",
    "buttons": {
      "assign": "Asignar",
      "edit": "Editar",
      "remove": "Eliminar"
    },
    "confirmDialog": {
      "title": "¿Eliminar aeronave del área de espera?",
      "text": "¿Está seguro de que desea eliminar {{identifier}} del área de espera?",
      "okButton": "Eliminar",
      "cancelButton": "Cancelar"
    }
  },
  "assignAircraftDialog": {
    "title": "Asignar aeronave a ubicación",
    "sections": {
      "hangars": "Hangares",
      "ramps": "Rampas"
    },
    "messages": {
      "mayBeTooSmall": "Puede ser muy pequeño",
      "noLocations": "No hay hangares o plataformas disponibles"
    },
    "buttons": {
      "cancel": "Cancelar",
      "assign": "Asignar",
      "assigning": "Asignando..."
    }
  },
  "holdingAreaPresenter": {
    "title": "Área de espera"
  },
  "holdingAreaList": {
    "title": "Área de espera ({{count}})",
    "emptyState": "No hay aeronaves en área de espera"
  },
  "printLayout": {
    "hangarCount": "{{count}} Hangar",
    "sqft": " ft²",
    "aircraft": "Aeronave",
    "utilization": "Utilización"
  },
  "multiHangarInfoCard": {
    "title": "Resumen multi-hangar",
    "labels": {
      "aircraft": "Aeronave",
      "utilization": "Utilización",
      "totalSqft": "Total pies²",
      "totalUtilized": "Total utilizado",
      "estValue": "Valor est.",
      "total": "Total",
      "transients": "Transients",
      "estTowTime": "Remolq. est."
    },
    "tooltips": {
      "numberOfHangars": "Número de hangares seleccionados",
      "aircraftCount": "Aeronaves en hangares / Total de aeronaves en hangares seleccionados",
      "utilization": "Utilización combinada en todos los hangares seleccionados",
      "totalSqft": "Área total de hangar en todos los hangares seleccionados",
      "totalUtilized": "Área total de piso ocupada por aeronaves",
      "estValue": "Valor combinado estimado de todos los hangares por día",
      "transientValue": "Revenue from overnight transient aircraft.",
      "estTowTime": "Tiempo total estimado de remolque en todos los hangares"
    }
  }
}
